<template>
  <b-card no-body>
    <h4 class="pl-1 pt-1">Qc</h4>
    <b-table striped hover :items="items" :fields="fields" small>
      <template #cell(actions)="data">
        <a href="#" @click.prevent="$bvModal.show(`modal-qc-${data.item.id}`)"
          ><i :class="`fa fa-lg fa-circle text-${data.item.color}`"></i
        ></a>
        <modal-qc :id="`modal-qc-${data.item.id}`" :data="data.item.inspection || {}"></modal-qc>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import ModalQc from "./ModalQc";
export default {
  name: "QcList",
  components: {
    ModalQc
  },
  data() {
    return {
      fields: [
        { key: "actions", label: "", class: "text-center" },
        { key: "potential_percentage", label: "%P", class: "text-center" },
        { key: "potential_kg", label: "KgsP", class: "text-center" }
      ]
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.reduce-padding {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
